import Vue from 'vue'

const types = {
  SET_LOCAL_STORE: 'SET_LOCAL_STORE',
}

export const localStoreActions = {
  setLocalStore({ commit }, { localStore }) {
    commit(types.SET_LOCAL_STORE, { localStore })
  },
}

export const localStoreGetters = {
  localStore: (state) => state.localStore,
}

export const localStoreMutations = {
  [types.SET_LOCAL_STORE](state, { localStore }) {
    Vue.set(state, 'localStore', localStore)
  },
}
